module.exports = __webpack_public_path__ + "img/menu-more.97ffe312.svg";